export enum VirtualTypeEnum {
    Position = "Position",
}